import { render } from "./KeyValueRow.vue?vue&type=template&id=159a1545&ts=true"
import script from "./KeyValueRow.vue?vue&type=script&lang=ts"
export * from "./KeyValueRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__